import { APICONFIG } from '@config/api.config';
import { APIService } from '@services/api/common-services';
import { useQuery } from '@tanstack/react-query';
import { IQueryResponse } from '@services/api';
import { ErrorHandler } from '@helper/errorHandler';
import { setRxdb } from '@helper/utils';
import { useCheckRxdb } from '@hooks/checkRxdb';

export interface ISpecialistDetails {
	mh2name_c: string;
	mh2code_c: string;
	sfid: string;
	phone_number_c: string;
}

export const useFetchSiteSpecialist = (): IQueryResponse<Array<ISpecialistDetails>> => {
	const { isDbChecked, shouldFetch } = useCheckRxdb('sitespecialist_list');

	const fetchSiteSpecialistListing = async (): Promise<Array<ISpecialistDetails>> => {
		try {
			const response = await APIService.getData<{ data: Array<ISpecialistDetails> }>(APICONFIG.SITE_SPECIALIST_LIST);

			if (response) {
				await setRxdb('sitespecialist_list', response.data);
			}
			return response.data;
		} catch (error) {
			ErrorHandler(error);
			return [];
		}
	};

	const { data, error, isLoading, isPending, isFetching, refetch } = useQuery({
		queryKey: ['siteSpecialistListing'],
		queryFn: fetchSiteSpecialistListing,
		enabled: isDbChecked && shouldFetch,
		refetchOnWindowFocus: false,
		retry: false,
	});

	return {
		data,
		error,
		isLoading,
		isPending,
		isFetching,
		refetch,
	};
};
